import * as React from "react";
const SvgPerson = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	width: 24,
	height: 24,
	rx: 12,
	fill: "#F2F3F7"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.99805 7C9.99805 5.89543 10.8935 5 11.998 5C13.1026 5 13.998 5.89543 13.998 7C13.998 7.70087 13.6375 8.31753 13.0918 8.67467C13.1611 8.69999 13.2356 8.72899 13.3167 8.76223C13.8994 9.00095 14.9413 10.0172 15.1945 10.5937C15.4716 11.2247 15.4785 11.5008 15.4923 12.0529C15.4948 12.1521 15.4961 12.2516 15.4961 12.3511C15.4961 13.3296 15.4961 13.8188 15.3362 14.2048C15.1231 14.7193 14.7143 15.1281 14.1997 15.3413C14.1352 15.368 14.0679 15.3902 13.9958 15.4088L13.996 15.5003C13.996 16.4438 13.9423 17.1782 13.8834 17.6996C13.8149 18.3075 13.416 18.8202 12.8139 18.9278C12.5761 18.9703 12.3076 19 12 19C11.6924 19 11.42 18.9703 11.1822 18.9278C10.5801 18.8202 10.1812 18.3075 10.1126 17.6996C10.0538 17.1782 10.0001 16.4438 10.0001 15.5003L10.0003 15.4088C9.92823 15.3902 9.86087 15.368 9.7964 15.3413C9.28182 15.1281 8.873 14.7193 8.65986 14.2048C8.5 13.8188 8.5 13.3296 8.5 12.3511C8.5 12.2516 8.50131 12.1521 8.50379 12.0529C8.51758 11.5008 8.52448 11.2247 8.80157 10.5937C9.05477 10.0172 10.0967 9.00095 10.6794 8.76223C10.7605 8.72899 10.835 8.69999 10.9042 8.67467C10.3586 8.31753 9.99805 7.70087 9.99805 7Z",
	fill: "#1D2023"
}));
export default SvgPerson;
